import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';
import { ActivatedRoute } from '@angular/router';
import { Location, LocationService } from 'services/location.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'ras-unit-reserved-page',
	templateUrl: './unit-reserved-page.component.html',
	styleUrls: ['./unit-reserved-page.component.sass']
})
export class UnitReservedPageComponent implements OnInit {

	public location: Location = null;
	public token: string
	public email: string
	public show_coupon_popup = true
	public location_name = "Centurion"
	public environment = environment;

	constructor(private metaService: MetaService, private route: ActivatedRoute, private locationService: LocationService) { }

	ngOnInit() {
		this.metaService.apply('unit-reserved')

		this.route.paramMap.subscribe(params => {
			let reservation_base64 = params.get('reservation')
			let reservation_json = atob(reservation_base64)
			let reservation = JSON.parse(reservation_json)

			let location_key = reservation.location
			this.token = reservation.token
			this.email = reservation.email

			this.locationService.get_all()
			.then(locations => {
				for (let location of locations) {
					if (location.key == location_key) {
						this.location = location
						break
					}
				}
			})
		});
	}

}
